import {environment} from '@tytapp/environments/environment';


export function buildBooleanSearchParams<T extends { [k in keyof T]: boolean }>(name: string, values: T) {
    return new URLSearchParams(
        Object.entries(values)
            .map(([item, value]) => [name, `${ value ? '' : '-' }${ item }`])
    );
}


export function parseBooleanSearchParams<T extends { [k in keyof T]: boolean }>(values: string[]): T {
    return Object.fromEntries(
        values.map(value => {
            const item = value.replace(/^-/, '');
            return [item, item === value];
        })
    ) as T;
}


export function appendSearchParams(href: string, params: URLSearchParams): string {
    // append search params this way in case href already has search params.
    const url = new URL(href, environment.urls.accounts); // base in case href is relative.
    for (const [key, value] of params) {
        url.searchParams.append(key, value);
    }
    return url.href;
}
